import * as React from 'react';
import { Typography } from 'components';
import styled from 'styled-components';

interface DriverFieldProps {
  name?: string;
  vehicle_plate_number?: string;
}

const DriverField = ({ name, vehicle_plate_number }: DriverFieldProps): JSX.Element => {
  const [isMobile, setIsMobile] = React.useState(
    window.matchMedia('(max-width: 768px)').matches
  );

  React.useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const handleResize = () => setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleResize);

    return () => {
      mediaQuery.removeEventListener('change', handleResize);
    };
  }, []);

  return (
    <Typography as="p" weight="normal" color="gray_600">
      {isMobile ? (
        <>
          {name}
          {vehicle_plate_number && <MobileVehicle>{vehicle_plate_number}</MobileVehicle>}
        </>
      ) : (
        [name, vehicle_plate_number].filter(Boolean).join(', ')
      )}
    </Typography>
  );
};

const MobileVehicle = styled.span`
  display: block;
  margin-top: 0.25rem;
`;

export default DriverField;
